import { catchError, map, switchMap } from 'rxjs/operators';
import { ModifyOrderState } from '@ordersnproducts/modules/new-modify-order/reducers';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  ProductActions,
  ProductLoadCompleteAction,
  ProductLoadFailAction,
  OP_PRODUCT_LOAD,
} from '../../../actions/products-actions/products.actions';
import { ProductOPReq, ProductsOpenPlatformService, ProductsResponseOP } from '@cemex-core/cmx-api';

/**
 * An effect which monitors the actions$ Observable for (job-site) LOAD operations
 * and then
 */
@Injectable()
export class ProductLoadEffects implements IEffect {
  productModifyLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OP_PRODUCT_LOAD),
      switchMap((action: ProductActions) => {
        const request: ProductOPReq = action.payload;

        return this.productsApi.getProducts(request).pipe(
          map((response: ProductsResponseOP) => {
            this.store.dispatch(new ProductLoadCompleteAction(response));
            return new ProductLoadCompleteAction(response);
          }),
          catchError((error) => of(new ProductLoadFailAction(error))),
        );
      }),
    ),
  );

  /**
   *
   * @param {Store<OrderBuilderState>} store the usual in-memory store of application state.
   * @param {Actions} actions$ an Observable subclass which deals with actions
   *                           taken by or in the application
   * @param {ProductLoaderService} productLoaderService
   */
  constructor(
    private store: Store<ModifyOrderState>,
    private actions$: Actions,
    private productsApi: ProductsOpenPlatformService,
  ) {}
}
